export const zopimLivechat = (lang) => {
  const chat = {
    ru: {
      chatlang: 'ru',
      startchat: 'Начать чат!',
      writeyourquestion: 'Напишите ваш вопрос или комментарий, и мы тут же ответим!',
      chatimg: '/images2019/zopim_support_pic.gif',
    },
    ua: {
      chatlang: 'uk',
      startchat: 'Почати чат!',
      writeyourquestion: 'Напишіть Ваше питання чи коментар, і ми одразу відповімо!',
      chatimg: '/images2019/zopim_support_pic_ukranian.gif',
    },
    en: {
      chatlang: 'en',
      startchat: 'Start chat!',
      writeyourquestion: 'Please enter your question or comment, and we will answer straight away',
      chatimg: '/images2019/zopim_support_pic_english.gif',
    }
  };

  const script = `setTimeout(() => { zE('webWidget', 'setLocale', "${chat[lang].chatlang}"); }, 500);`;

  const settings = `window.zESettings={webWidget:{launcher:{badge:{image:"${chat[lang].chatimg}"},chatLabel:{"*":"${chat[lang].startchat}"}},chat:{prechatForm:{greeting:{"*":"${chat[lang].writeyourquestion}"}}},color:{theme:"#258db3",launcher:"#258db3",header:"#258db3"}}};`;

  return script + settings;
};
